import React, { useState } from 'react';

import { DropdownOptionButton } from '.';
import { defaultDisabled, defaultSize, defaultWidths } from './constants';

/**
 * A DropdownOptionButton that is positioned to the right, allowing for a nested menu layout.
 * @param {DropdownNestedOptionProps} props
 */
export const DropdownNestedOption = (
    props: DropdownNestedOptionProps,
): JSX.Element => {
    const {
        addClasses,
        borderConfig,
        boxShadowWhenClosed,
        boxShadowWhenOpen,
        children,
        height,
        label,
        leftPadding,
        Icon,
        disabled = defaultDisabled,
        size = defaultSize,
    } = props;

    const width = props?.width ?? defaultWidths[size];
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            <DropdownOptionButton
                addClasses={addClasses}
                borderConfig={borderConfig}
                boxShadowWhenClosed={boxShadowWhenClosed}
                boxShadowWhenOpen={boxShadowWhenOpen}
                handleClick={(): void => {
                    setIsExpanded(!isExpanded);
                }}
                height={height}
                Icon={Icon}
                label={label}
                leftPadding={leftPadding}
                disabled={disabled}
                size={size}
                width={width}
            />
            {isExpanded && (
                <div className="relative">
                    <div
                        className="absolute"
                        style={{
                            left: width - 2,
                            top: -height,
                            width,
                            height,
                        }}
                    >
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};
